"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAccommodationCancellationPolicies = void 0;
var formatDate_1 = require("./formatDate");
var date_1 = require("./date");
var buildAccommodationCancellationPolicies = function (rate, options) {
    var policyDescriptions = [];
    var policies = rate.cancellationPolicies;
    var now = new Date();
    // if there are no policies, or if all policies have ended or all running policies are non refundable, we return a non refundable policy
    if (!(policies === null || policies === void 0 ? void 0 : policies.length) || policies.every(function (policy) {
        var policyHasEnded = policy.end && new Date(policy.end) < now;
        var policyIsNonRefundable = policy.nonRefundable;
        var policyHasStarted = policy.start && new Date(policy.start) < now;
        return policyHasEnded || (policyHasStarted && policyIsNonRefundable);
    })) {
        return {
            policies: [],
            description: [
                'If you cancel your booking, you are not eligible for a refund or credit for a future stay.',
            ],
        };
    }
    var expired = policies.filter(function (policy) { return policy.end && new Date(policy.end) < now; });
    if (rate.fullRefundableUntil && date_1.isAfter(rate.fullRefundableUntil, now)) {
        policyDescriptions.push("Free accommodation cancellation until " + formatDate_1.formattedDateByTimezoneSimple(rate.fullRefundableUntil, { timezone: options.timezone }) + " (local time of property)" + (options.hideExcludesFlights ? '' : ', excludes flights') + ".");
    }
    for (var i = 0; i < rate.cancellationPolicies.length; i++) {
        var policy = rate.cancellationPolicies[i];
        if (i === 0) {
            if (rate.fullRefundableUntil) {
                var dateFormat = formatDate_1.formattedDateByTimezoneSimple(rate.fullRefundableUntil, { timezone: options.timezone });
                policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) will result in a " + policy.amount + " " + options.currencyCode + " fee.");
            }
            else {
                // we dont have a full refundable until date, so we use the start date of the first policy minus 1ms to get the last day of the previous policy
                var dateFormat = formatDate_1.formattedDateByTimezoneSimple(date_1.subMilliseconds(new Date(policy.start), 1), { timezone: options.timezone });
                policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) will result in a " + policy.amount + " " + options.currencyCode + " fee.");
            }
        }
        else if (i > 0 && rate.cancellationPolicies[i - 1].end) {
            // the end date of the previous policy is the exclusive start date of the current policy
            // due to the wording of the policy, we need to use the exclusive date so it's easier to understand for the user
            var dateFormat = formatDate_1.formattedDateByTimezoneSimple(rate.cancellationPolicies[i - 1].end, { timezone: options.timezone });
            policyDescriptions.push("Cancellations made after " + dateFormat + " (local time of property) will result in a " + policy.amount + " " + options.currencyCode + " fee.");
        }
        else {
            policyDescriptions.push(policy.description);
        }
    }
    policyDescriptions.push('If you fail to check-in for this reservation, or if you cancel or change this reservation after check-in, you may incur penalty charges at the discretion of the property of up to 100% of the booking value.');
    return {
        policies: expired.length < rate.cancellationPolicies.length ? rate.cancellationPolicies : [],
        description: policyDescriptions,
    };
};
exports.buildAccommodationCancellationPolicies = buildAccommodationCancellationPolicies;
